// Color de identidad del módulo Caja Técnica — mismo patrón que las otras Cajas.
export const CAJA_TECNICA_COLOR = "#37474f";
